import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {sendOrder} from "../actions/order";
import {toast} from "react-toastify";

const ModalForm = ({order}) => {
    const showModal = useSelector(state => state.modalForm.show);
    const dispatch = useDispatch();
    const [name, setName] = useState('');
    const [phone, setPhone] = useState('');
    const [commentary, setCommentary] = useState('');
    const product = useSelector(state => state.productDetail.product) || {};
    const amount = useSelector(state => state.modalForm.amount) || {};

    const hideModal = () => {
        dispatch({type: 'HIDE_MODAL_FORM'});
    };

    const createOrder = () => {
        if (name !== '' && phone !== ''){
            const fieldOrder = {};
            fieldOrder.name = name;
            fieldOrder.phoneNumber = phone;
            fieldOrder.commentary = commentary;
            fieldOrder.title = product.title;
            fieldOrder.size = product.size;
            fieldOrder.amount = amount.toString();
            dispatch(sendOrder(fieldOrder));
            dispatch({type: 'HIDE_MODAL_FORM'});
            setName('');
            setPhone('');
            setCommentary('');
        } else {
            toast.warning('Поля "Имя" и "Телефон" должны быть заполнены!', {
                position: 'bottom-right',
                autoClose: true
            })
        }

    }

    const handleChangeName = (event) => {
        setName(event.target.value);
    };

    const handleChangePhone = (event) => {
        setPhone(event.target.value);
    };

    const handleChangeCommentary = (event) => {
        setCommentary(event.target.value);
    };
    return (
        <div>
            <div className={`modal fade ${showModal && 'show'}`}
                 style={{display: showModal && 'block', paddingRight: showModal && '17px'}} role="dialog">
                <div className="modal-dialog " role="document">
                    <div className="modal-content">
                        <button onClick={(e) => {
                            hideModal();
                        }} type="button" className="close" data-dismiss="modal" aria-label="Close">
                            <span><i className="icon-x"></i></span>
                        </button>
                        <div className="modal_body">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="contact_message form">
                                            <h3>Сделать заказ</h3>
                                            <p>
                                                <label> Ваше имя</label>
                                                <input name="name" placeholder="Имя *" type="text" value={name} onChange={handleChangeName}/>
                                            </p>
                                            <p>
                                                <label> Номер телефона</label>
                                                <input name="subject" placeholder="Телефон *" type="text" value={phone} onChange={handleChangePhone}/>
                                            </p>
                                            <div className="contact_textarea">
                                                <label> Комментарий к заказу(не обязательно)</label>
                                                <textarea placeholder="Комментарий" name="message"
                                                          className="form-control2" value={commentary} onChange={handleChangeCommentary}></textarea>
                                            </div>
                                            <button onClick={() => {createOrder()}}>Заказать</button>
                                            <p className="form-messege"></p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div onClick={(e) => {
                hideModal();
            }} className={showModal && 'modal-backdrop fade show'}></div>
        </div>
    );
};

export default ModalForm;